/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAddressParts } from '@/utils/getAddressParts';

export const getReviewEntityTitle = (
	fieldKey: string,
	newItem: any,
	oldItem: any
): string => {
	const item = newItem || oldItem;
	if (!item) return '';

	if (fieldKey === 'licenses') return item.licenseNumber_V || 'License';

	if (fieldKey === 'addresses') {
		const address = getAddressParts(item, { includeCountry: true }).join(', ');
		if (address) return address;

		const street = item.streetAddress1Cda_V;
		const city = item.cityCda_V;

		if (street) return `${street}${city ? `, ${city}` : ''}`;
	}

	if (fieldKey === 'parenthcos') return item.hcoNameCda_V;
	if (item.name) return item.name;

	return '';
};
